import React, { Component } from 'react'
import Modal from 'react-responsive-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import styles from "./styles.css";
export default class CustomAlertV2 extends Component {

  render() {
    const { error } = this.props
    return (
      <div>
        <Modal
          closeOnOverlayClick={false}
          showCloseIcon={false}
          styles={{ modal: { backgroundColor: '#f9f9f9', padding: 0, borderRadius: 15, } }}
          open={this.props.open}
          onClose={this.props.onClose}
          center
        >
          <div className='successContainer'>
            <div className='iconContainer'>
              <div className={error ? 'errorIcon' : 'successIcon'}>
                <FontAwesomeIcon icon={error ? faTimes : faCheck} size='5x' color={'#FFFFFF'} />
              </div>
            </div>
            <div className='titleContainer'>
              <h3 className='titleText'>{error ? 'Error' : 'Request Submitted'}</h3>
            </div>
            <div className='subtitleContainer'>
              <h5
                className='subtitleText'
                dangerouslySetInnerHTML={{
                  __html: this.props.message.replace(/\n/g, '<br />'),
                }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 15 }}>
              <button
                onClick={this.props.onClose}
                className='modalButton'
              >
                {error ? 'Try Again' : 'Done'}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
